export const shouldReportActivityModalExposure = (previousOpen, currentOpen) => (
    !previousOpen && currentOpen
);

export const getNextActivityModalExposureLatch = (isOpen, wasOpen, didReport) => {
    if (!isOpen) {
        return false;
    }
    if (wasOpen) {
        return true;
    }
    return Boolean(didReport);
};

const hasUsableCouponInfo = (plan) => (
    Boolean(plan)
    && typeof plan === 'object'
    && !Array.isArray(plan)
    && Boolean(plan.coupon_info)
    && typeof plan.coupon_info === 'object'
);

export const buildActivityModalExposureData = (pricingPlan, calculateDiscount) => {
    const planRes = pricingPlan?.data;
    const monthlyPlans = planRes?.meal_list?.month;
    if (
        typeof calculateDiscount !== 'function'
        || !Array.isArray(monthlyPlans)
        || !hasUsableCouponInfo(monthlyPlans[0])
        || !hasUsableCouponInfo(monthlyPlans[1])
    ) {
        return null;
    }

    const planInfo = {
        pro: calculateDiscount(planRes, monthlyPlans[0]),
        pre: calculateDiscount(planRes, monthlyPlans[1]),
    };

    return {
        source_type: 'promotion',
        planRes,
        planInfo,
        selData: planInfo.pro,
    };
};
